module.exports = __webpack_public_path__ + "img/position.9daf427d.png";